<div class="col-12 billet-wks-component" [ngClass]="{'isBilletFloat': isBilletFloat}">
  <div class="row">
    <mat-tab-group class="typeOrderWks" [style]="{height:'275px'}"  id="scroll-typeOrder-{{ cardId }}"  (selectedTabChange)="changeTabSide($event)"
      [selectedIndex]="tabChangeSide">
      <mat-tab label="Comprar" class="border-buy">
        <div class="col-12">
          <app-billet-wks-inputs [withBackground]="true" [symbol]="symbol" [model]="model" [messageQuote]="messageQuote"
            [typeOrder]="model.type" [sideOrder]="model.side" [strategyOptions]="strategyOptions"
            (openConfirmationBillit)="openModalConfirm($event)" [auctionHammer]="model?.auctionHammer"
            [typeOrderOptions]="typeOrderOptions" [listPosition]='listPosition' [isBilletFloat]="isBilletFloat"
            [typeOrderSelected]="typeOrderSelected" [financialAccount]="financialAccount">
          </app-billet-wks-inputs>
        </div>
      </mat-tab>
      <mat-tab label="Vender" class="border-sell">
        <div class="col-12">
          <app-billet-wks-inputs [withBackground]="true" [symbol]="symbol" [model]="model" [messageQuote]="messageQuote"
            [typeOrder]="model.type" [sideOrder]="model.side" [strategyOptions]="strategyOptions"
            (openConfirmationBillit)="openModalConfirm($event)" [auctionHammer]="model?.auctionHammer"
            [typeOrderOptions]="typeOrderOptions" [listPosition]='listPosition' [isBilletFloat]="isBilletFloat"
            [typeOrderSelected]="typeOrderSelected" [financialAccount]="financialAccount">
          </app-billet-wks-inputs>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
